
export default {
  name: 'BoxIcon',
  props: {
    name: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '24px',
    },
  },
  data: () => ({}),
  computed: {
    isThemeDefault() {
      return this.$session.get('brand') === '';
    },
    isThemeSeat() {
      return this.$session.get('brand') === 'seat';
    },
    fontSize() {
      let size = '';
      switch (this.size) {
        case 'xs':
          size = '16px';
          break;
        case 'sm':
          size = '18px';
          break;
        case 'md':
          size = '24px';
          break;
        case 'lg':
          size = '26px';
          break;
        case 'xl':
          size = '28px';
          break;
        case '':
        case null:
        case undefined:
          size = '24px';
          break;
        default:
          size = this.size;
      }
      return size;
    },
  },
  methods: {},
};
